import React from "react";
import { Box, Typography } from "@mui/material";
import {
  CURRENT_TASK_PROGRESS,
  CURRENT_WEEK_TASK,
  DUE_DATE,
  ENROLLMENT_DATE,
  PATIENT_STATUS,
  REWARD_POINTS,
  REWARDS_TIER_LEVEL,
} from "../../utility/constants/locale";
import CustomLinearProgressBar from "../../components/custom-linear-progress-bar/CustomLinearProgressBar";

interface PatientDetailsCardProps {
  values: {
    enrollmentDate: string;
    dueDate: string;
    patientStatus: string;
    displayGroupDisplayName: string;
    currentTaskProgress: string;
    rewardsTierLevel: string;
    rewardPoints: string;
    totalRewardPoints: number;
  };
}

const PatientDetailsCard: React.FC<PatientDetailsCardProps> = ({ values }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        backgroundColor: "#F2EEE8",
        padding: "30px",
        borderRadius: "10px",
        width: "95%",
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="body2" fontWeight="700">
          {ENROLLMENT_DATE}
        </Typography>
        <Typography variant="body2">{values.enrollmentDate}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="body2" fontWeight="700">
          {DUE_DATE}
        </Typography>
        <Typography variant="body2">{values.dueDate}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="body2" fontWeight="700">
          {PATIENT_STATUS}
        </Typography>
        <Typography variant="body2">{values.patientStatus}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="body2" fontWeight="700">
          {CURRENT_WEEK_TASK}
        </Typography>
        <Typography variant="body2">
          {values.displayGroupDisplayName}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="body2" fontWeight="700">
          {REWARDS_TIER_LEVEL}
        </Typography>
        <Typography variant="body2">{values.rewardsTierLevel}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="body2" fontWeight="700">
          {REWARD_POINTS}
        </Typography>
        <Box display="flex" alignItems="center">
          <Typography variant="body2" sx={{ color: "#CF489A" }}>
            {values.rewardPoints}
          </Typography>
          <Typography variant="body2">{`/${values.totalRewardPoints}`}</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Typography variant="body2" fontWeight="700">
          {CURRENT_TASK_PROGRESS}
        </Typography>
        <CustomLinearProgressBar
          value={Number(values.currentTaskProgress)}
          backgroundColor="#FFFFFF"
        />
      </Box>
    </Box>
  );
};

export default PatientDetailsCard;
